export default "__VITE_ASSET__BK2dsfxJ__"